"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrToString = arrToString;
exports.clampBuilder = clampBuilder;
exports.debounce = debounce;
exports.extractBynderVideoSources = void 0;
exports.filterNull = filterNull;
exports.formatAttribution = formatAttribution;
exports.generateGUID = void 0;
exports.getClickable = getClickable;
exports.getCookieValue = getCookieValue;
exports.getDefaultEnv = exports.getDataPartial = void 0;
exports.getQueryParamValue = getQueryParamValue;
exports.handleModifierKeyAnchorClick = handleModifierKeyAnchorClick;
exports.isContentfulId = isContentfulId;
exports.isSitecoreGuid = isSitecoreGuid;
exports.isValidId = isValidId;
exports.ms = ms;
exports.objToCssVar = objToCssVar;
exports.scrollToAnchor = scrollToAnchor;
exports.scrollToTop = scrollToTop;
exports.sortWithEnglishFirst = sortWithEnglishFirst;
exports.urlJoin = urlJoin;
exports.useClickOutside = useClickOutside;
exports.useDeviceDetect = useDeviceDetect;
exports.useEventListener = useEventListener;
exports.useIsRTL = useIsRTL;
exports.useIsomorphicLayoutEffect = void 0;
exports.useWidthObserver = useWidthObserver;
exports.useWindowSize = useWindowSize;
var _breakpoints = require("./breakpoints.js");
var _react = _interopRequireWildcard(require("react"));
var _resizeObserver = _interopRequireDefault(require("@react-hook/resize-observer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Animated ScrollTo functionality
 *
 * @param {string} currentTarget The item that has a data-target on it
 * @param {number} offset Scroll Offset (optional)
 * @returns {null} returns nothing, just an animation
 */
function scrollToAnchor(currentTarget, offset = 50) {
  if (typeof document !== 'undefined') {
    const target = currentTarget?.dataset?.target;
    const element = document.getElementById(target);
    if (element && typeof window !== 'undefined') {
      setTimeout(() => {
        window.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop - offset
        });
      }, 100);
    }
  }
  return null;
}

/**
 * Simplified modular scale.
 *
 * @param {Number} v Value
 * @param {Number} base Base (rem) to scale
 * @param {Number} ratio Ratio to scale
 * @returns {Number} modular scale
 * @private
 */
function ms(v, base = 1, ratio = 1.125) {
  return Math.pow(ratio, v) * base;
}

/**
 * clampBuilder
 * Headline and Display font css clamp() generator
 *
 * @param {Number} minFontSize minFontSize
 * @param {Number} maxFontSize maxFontSize
 * @returns {String} css string for clamp func
 */

function clampBuilder(minFontSize, maxFontSize) {
  minFontSize = parseFloat(minFontSize);
  maxFontSize = parseFloat(maxFontSize);
  const minWidth = _breakpoints.size.tablet / 16;
  const maxWidth = _breakpoints.size.laptopLg / 16;
  const slope = (maxFontSize - minFontSize) / (maxWidth - minWidth);
  const yAxisIntersection = -minWidth * slope + minFontSize;
  return `clamp( ${minFontSize}rem, ${yAxisIntersection}rem + ${slope * 100}vw, ${maxFontSize}rem )`;
}

/**
 * objToCssVar
 *
 * @param {Object} obj obj
 * @param {String} key key
 * @returns {String} string of custom properties
 */
function objToCssVar(obj, key) {
  return Object.entries(obj).map(item => `--${key}-${item[0]}: ${item[1]};`).join('');
}

/**
 * useWindowSize
 *
 * @returns {Object} hook
 */
function useWindowSize() {
  const [windowSize, setWindowSize] = (0, _react.useState)({
    width: 0,
    height: 0
  });
  function changeWindowSize() {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }
  (0, _react.useEffect)(() => {
    if (typeof document !== `undefined` && typeof window !== `undefined`) {
      changeWindowSize();
      window.addEventListener('resize', changeWindowSize);
      return () => {
        window.removeEventListener('resize', changeWindowSize);
      };
    }
  }, []);
  return windowSize;
}

/**
 * useDeviceDetect
 *
 * @returns {Object} hook
 */
function useDeviceDetect() {
  const [isMobile, setMobile] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (typeof document !== `undefined` && typeof window !== `undefined`) {
      const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
      const mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
      setMobile(mobile);
    }
  }, []);
  return {
    isMobile
  };
}

/**
 * formatAttribution
 *
 * @param {String} rawAttribution raw unformatted attribution string
 * @param {Boolean} onlyBoldLineOne bold only line one of attribution
 * @returns {React.ReactElement} formatted attribution
 */
function formatAttribution(rawAttribution, onlyBoldLineOne = false) {
  const lines = rawAttribution?.trim().replace('<p>', '').replace('</p>', '').replaceAll('&quot;', '"').split('\n');
  return lines?.map((line, i) => {
    if (line.match(/[a-zA-Z0-9]+\.[a-zA-Z0-9]/) || onlyBoldLineOne && i > 0) {
      return /*#__PURE__*/_react.default.createElement("span", {
        key: i,
        style: {
          fontWeight: 'initial'
        }
      }, line);
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: i
    }, line, i !== lines.length - 1 && /*#__PURE__*/_react.default.createElement("br", null));
  });
}

/**
 * urlJoin
 *
 * @param {String} url original url string
 * @param {String} addition string to add to end of url path
 * @returns {String} string with addition joined with url
 */

function urlJoin(url, addition) {
  const joinUrl = (base, part) => base + (base.endsWith('/') ? part : `/${part}`);
  let base = url;
  let part = addition;
  const queryParams = /\?.*/.exec(url);
  if (queryParams) {
    base = url.substring(0, queryParams.index);
    part = addition + queryParams;
  }
  return joinUrl(base, part);
}

/**
 * useEventListener
 *
 * @param {string} event event name
 * @param {function} handler Assigned Handler Function on keyCode
 * @param {Object} element the target of the event listener, will default to document if possible
 */
function useEventListener(event, handler, element = null) {
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      const target = element ? element : document;
      target.addEventListener(event, handler);
      return () => target.removeEventListener(event, handler);
    }
    return;
  }, [event, handler, element]);
}

/**
 * useClickOutside
 *
 * @param {number} element element whose contents are considered inside
 * @param {function} handler Assigned Handler Function on event
 * @param {string} eventName event for handler
 * @param {Object} container the target of the event listener, will default to document if possible
 */
function useClickOutside(element, handler, eventName = 'click', container = null) {
  const onClickEvent = (0, _react.useCallback)(evt => {
    const targetIsOutside = element && evt.target !== element && !element.contains(evt?.target);
    if (targetIsOutside) {
      handler(evt);
    }
  }, [element, handler]);
  useEventListener(eventName, onClickEvent, container);
}

/**
 * useWindowSize
 *
 * @param {Node} target Target Element
 * @returns {Number} hook
 */
function useWidthObserver(target) {
  const [width, setWidth] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    if (target?.current && target.current instanceof HTMLElement) setWidth(target.current.clientWidth);
  }, [target]);
  (0, _resizeObserver.default)(target, entry => setWidth(entry.target.clientWidth));
  return width;
}
const useIsomorphicLayoutEffect = exports.useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;

/**
 * useIsRTL
 * Checks whether the document body has a right-to-left direction.
 * @returns {Boolean} condition value
 */
function useIsRTL() {
  const [isRTL, setIsRTL] = (0, _react.useState)(false);
  (0, _react.useLayoutEffect)(() => {
    setIsRTL(typeof window !== 'undefined' && window?.getComputedStyle(document?.body)?.direction === 'rtl');
  }, []);
  return isRTL;
}
function getCookieValue(name) {
  if (typeof document === 'undefined') return '';
  const value = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return value ? value.pop() : '';
}
function getQueryParamValue(name) {
  if (typeof window === 'undefined') {
    return '';
  }
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name) || '';
}

/**
 * Returns the default environment based on the window host
 *
 * @returns {string} Default environment ('dev', 'test', or 'prod')
 */
const getDefaultEnv = () => {
  if (typeof window === 'undefined') {
    return 'prod';
  }
  const host = window.location.host;
  if (/dev/.test(host) || /origin-swp\.dev/.test(host)) {
    return 'dev';
  } else if (/test/.test(host) || /origin-swp\.test/.test(host)) {
    return 'test';
  }
  return 'prod';
};
exports.getDefaultEnv = getDefaultEnv;
const isString = value => typeof value === 'string';

/**
 * isContentfulId
 * Checks a string to see if it is a Contentful id
 * @param {string} str string we try to match
 * @returns {Boolean} does the value match a contentful id
 */
function isContentfulId(str) {
  if (!str || !isString(str)) {
    return false;
  }
  const guidPattern = /^(?:\w{10}|\w{21}|\w{22})$/;
  return !!str.match(guidPattern);
}

/**
 * isSitecoreGuid
 * Checks a string to see if it is a Sitecore GUID
 * @param {string} str string we try to match
 * @returns {Boolean} does the value match a sitecore GUID.
 */
function isSitecoreGuid(str) {
  if (!str || !isString(str)) {
    return false;
  }
  const guidPattern = `\\w{8}-\\w{4}-\\w{4}-\\w{4}-\\w{12}`;
  const GUIDRegExp = new RegExp(`^${guidPattern}$|^{${guidPattern}}$`);
  return !!str.match(GUIDRegExp);
}

/**
 * isValidId
 * Checks a string to see if it is a valid ID
 * @param {string} str string we try to match
 * @returns {Boolean} does the value match a valid ID.
 */
function isValidId(str) {
  return isContentfulId(str) || isSitecoreGuid(str);
}

/**
 * getClickable
 * Retrieves clickable elements from the given reference.
 * @param {Object} ref - The reference to the element containing clickable elements.
 * @returns {HTMLElement|null} - The last clickable element found, or null if none are found.
 */
function getClickable({
  ref
}) {
  const clickables = ref.current?.querySelectorAll('button, a') || [];
  const disqualifiers = ref.current?.querySelectorAll('input:not([type="hidden"])') || [];
  if (clickables.length && !disqualifiers.length) {
    return clickables[clickables.length - 1];
  }
  return null;
}

/**
 * sortWithEnglishFirst
 * Sorts an array of strings or objects, with English strings/property values sorted first.
 * If the array contains objects, the property to sort by can be specified.
 *
 * @param {Array} array - The array of strings or objects to be sorted.
 * @param {string} [propertyName=null] - If the array contains objects, this parameter specifies
 *                                       the name of the property to sort by. If the array contains
 *                                       strings, this parameter should be omitted.
 *
 * @returns {Array} - The sorted array.
 */
function sortWithEnglishFirst(array, propertyName = null) {
  const isEnglish = str => !/[^ -~]/g.test(str);
  return array?.sort((a, b) => {
    const aValue = propertyName ? a[propertyName] : a;
    const bValue = propertyName ? b[propertyName] : b;
    const aIsEnglish = isEnglish(aValue);
    const bIsEnglish = isEnglish(bValue);
    if (aIsEnglish && bIsEnglish) {
      return aValue.localeCompare(bValue);
    } else if (aIsEnglish) {
      return -1;
    } else if (bIsEnglish) {
      return 1;
    }
    return aValue.localeCompare(bValue);
  });
}

/**
 * filterNull
 * Removes Null objects from array
 *
 * @param {Array} array - The array of strings or objects to be sorted.
 *
 * @returns {Array} - The array without null elements.
 */
function filterNull(array) {
  return array?.filter(n => n);
}

/**
 * Converts an array to strings.
 * @param {Array} arr - An array of strings.
 * @param {String} delim - delimiter to use for strings
 * @returns {string|null} A string of values or null.
 */
function arrToString(arr, delim = ' ') {
  if (arr && Array.isArray(arr)) {
    return arr.join(delim);
  }
  return null;
}

/**
 * scrollToTop
 *
 * @returns {null} Smooth scroll to top
 * @private
 */

function scrollToTop() {
  if (typeof window !== 'undefined') {
    window?.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
/**
 * Custom event for handling cmd/shift/control + click.
 * @param {HTMLEvent} e - Event which triggers the cmd + click.
 * @param {HTMLObject} elementToClick - Element which will be clicked
 */
function handleModifierKeyAnchorClick(e, elementToClick) {
  e.preventDefault();

  // If the anchor does not have an eid, we need to render the tracking attributes
  const eid = elementToClick?.dataset?.eid;
  !eid && window?.cms?.trackingData?.renderTrackingAttrs(elementToClick);
  var clickEvent = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey
  });
  elementToClick.dispatchEvent(clickEvent);
}

/**
 * Debounce function
 * Executes the function and returns the value.
 * In this case the function returns void
 *
 * @param {Function} func Function to debounce
 * @param {Number} wait Amount of time to delay function execution
 * @param {Boolean} immediate Whether to execute immediately or not
 * @returns {void} Nothing is returned
 * @public
 */
function debounce(func, wait = 500, immediate) {
  let timeout;
  return function executedFunction() {
    const context = this;
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
}

/**
 * Extracts video sources from React element with video props
 * @param {Object} videos - React element with video props
 * @param {Object} options - Optional parameters
 * @param {String} options.thumbnailDesktop - Custom desktop thumbnail URL
 * @param {String} options.thumbnailMobile - Custom mobile thumbnail URL
 * @returns {Object} Formatted video source object
 */
const extractBynderVideoSources = (videos = [], {
  thumbnailDesktop,
  thumbnailMobile
} = {}) => {
  if (! /*#__PURE__*/_react.default.isValidElement(videos)) return {};
  const {
    desktopWebM,
    mobileWebM
  } = videos.props || {};
  const getWebmUrl = mediaArray => {
    if (!Array.isArray(mediaArray) || !mediaArray.length) return null;
    return mediaArray[0]?.selectedFile?.url;
  };
  const getThumbnailUrl = mediaArray => {
    if (!Array.isArray(mediaArray) || !mediaArray.length) return null;
    return mediaArray[0]?.thumbnails?.webimage;
  };
  const getMp4Url = mediaArray => {
    if (!Array.isArray(mediaArray) || !mediaArray.length) return null;
    return mediaArray[0]?.videoPreviewURLs?.[0];
  };
  return {
    // Desktop
    fallback: thumbnailDesktop || getThumbnailUrl(desktopWebM),
    laptop: getMp4Url(desktopWebM),
    laptopWebm: getWebmUrl(desktopWebM),
    // Mobile
    fallbackMobile: thumbnailMobile || getThumbnailUrl(mobileWebM),
    base: getMp4Url(mobileWebM),
    baseWebm: getWebmUrl(mobileWebM)
  };
};

/**
 * Generates a random GUID (Globally Unique Identifier) in the format 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.
 * The GUID is generated using random numbers and follows the version 4 UUID standard.
 *
 * @returns {string} A randomly generated GUID.
 */
exports.extractBynderVideoSources = extractBynderVideoSources;
const generateGUID = () => self.crypto.randomUUID();

/**
 * Helper function to get data-partial value
 * @param {string} partial - The partial value
 * @param {boolean} invert - Whether to invert the theme
 * @returns {string} The data-partial value
 */
exports.generateGUID = generateGUID;
const getDataPartial = (partial, invert) => {
  return partial || (invert ? 'dark1' : '');
};
exports.getDataPartial = getDataPartial;